


















import { Component, Vue } from 'vue-property-decorator'
import { User } from '@/types/auth'


@Component
export default class Login extends Vue {
    User = User

    selectUser(user: User) {
        this.$store.commit('updateUser', user)
    }
}
